import { ReferralTokenAttributes } from '@mc/api'
import { createContext } from 'react'

export type ShareContextData = {
  title: string
  source: ReferralTokenAttributes['source']
  course?: {
    id?: string | number | null
    instructorName?: string | null
    slug?: string | null
  } | null
  chapter?: {
    id?: string | number | null
    slug?: string | null
  } | null
  article?: {
    id?: string | number | null
    slug?: string | null
  } | null
  gem?: {
    id?: string | number | null
    slug?: string | null
  } | null
  recipe?: {
    id?: string | number | null
  } | null
  modalImage?: string | null
}

const ShareContext = createContext<ShareContextData | null>(null)

export default ShareContext
